import styled from "styled-components";

export const HomeContainer = styled.div`
  height: 100%;
  width: 100%;
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: -8em;
`;
